import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';


const SeleccionFormularios = (props) => {
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.FORMULARIO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState(null);
  const [reload, setReload] = useState(true)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    async function traerUsuarios(formulario,formulario1,formulario2,formulario3,formulario4,codigo) {
      const data = new FormData();
      data.append("formulario",formulario)
      data.append("formulario1",formulario1)
      data.append("codigo",codigo)
      if(codigo=='A04'){
        data.append("formulario2",formulario2)
        data.append("formulario3",formulario3)
        data.append("formulario3",formulario4)
      }
      await fetch(APITABLASBASICAS + 'SeleccionFormularios', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setReload(false)
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
        traerUsuarios(props.formulario,props.formulario1,props.formulario2,
        props.formulario3,props.formulario4,props.codigo)
  }, [reload,props.formulario,props.formulario1,props.formulario2,props.formulario3,
    props.formulario4,props.codigo]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
    return props.handleplanta(event.code,10)
  };

  const handleClick = (event) => {
    return props.handleplanta('',1000)
  };


  return (
    <div className="p-error">
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      onClick={(e) => handleClick(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionFormularios;
